import service from './service.js';

export class ReportService {

    getPermReport(hash, linkId, lang) {
        //returns Promise object
        return service.getRestClient().post('/api/getPermReport', JSON.stringify({
            hash: hash,
            linkId: linkId,
            language: lang
        }));
    }

    getPermReportPdf(hash, linkId, documentName, reportType, language) {
        //returns Promise object
        return service.getRestClient().post('/api/getPermReportPDF', JSON.stringify({
            hash: hash,
            linkId: linkId,
            documentName: documentName,
            reportType: reportType,
            language: language
        }));
    }
    
    getPdfInstructions(language) {
        //returns Promise object
        return service.getRestClient().post('/api/getPdfInstructions', JSON.stringify({
            language: language
        }));
    }

}

export default (new ReportService());